<template>
  <section>
    <PageName title="Договоры с агентством" :buttons="this.buttons" />

    <Preloader v-if="contractsLoading" />

    <VTable
        v-show="!contractsLoading"
        itemsType="array"
        :columns="contractsColumns"
        :items="mapedContracts"
        :sortApi="sortContracts"
        :selectedIndices="selectedIndices"
        @select="select"
        @row-click="openContract"
        selectable
        ref="table"
    />
  </section>
</template>

<script>
import {simpleDate} from "@/utils/filters/dateFilters";
import {mapActions, mapState, mapGetters} from "vuex";
import {deleteContracts} from "@/api/contracts";
import PageName from "@/components/PageName";
import Preloader from "@/components/Preloader";
import VTable from "@/components/Table/VTable";

export default {
  name: "Contracts",
  components: {
    PageName,
    Preloader,
    VTable
  },

  data() {
    return {
      selectedContractsIds: [],
      contractsColumns: [
        { title: "№", sort: false, value: "id" },
        { title: "№ договора", sort: false, value: "name" },
        { title: "Дата договора", sort: false, value: "contract_at" },
        { title: "Создан", sort: false, value: "created_at" },
        { title: "Изменен", sort: false, value: "updated_at" }
      ],
      paramsWidthSort: {
        page: 1,
        sort: 'id',
        search: '',
      },
      search: '',
      buttons: [
          {
            text: "Создать",
            icon: "addFile",
            event: this.create || {},
          },
          {
            text: "Удалить",
            icon: "delete",
            event: this.delete || {},
            iconWidth: "12px",
          }
        ]
      }
  },

  async mounted() {
    this.getContracts()
  },

  computed: {
    ...mapState("contracts", ["contracts", "contractsLoading"]),
    ...mapGetters('contracts', ['getContractsListPagination']),

    // pagination () {
    //   return this.getContractsListPagination
    // },
    mapedContracts() {
      return this.contracts?.map(contract => {
        return [
          contract.id,
          contract.name || "-",
          contract.contract_at ? simpleDate(contract.contract_at) : "-",
          contract.created_at ? simpleDate(contract.created_at) : "-",
          contract.updated_at ? simpleDate(contract.updated_at) : "-",
        ];
      });
    },
    selectedIndices: {
      get() {
        const indeces = [];

        this.contracts.forEach((contract, i) => {
          if (this.selectedContractsIds[contract.id] !== undefined) {
            indeces.push(i);
          }
        });

        return indeces;
      },
      set(val) {
        const ids = [];
        for (let index = 0; index < val.length; index++) {
          const contract = this.contracts[val[index]];
          if (contract?.id) ids[contract.id] = contract;
        }
        this.selectedContractsIds = ids;
      },
    },
  },

  methods: {
    ...mapActions("contracts", ["getContracts"]),

    openContract(num) {
      const node = this.contracts[num - 1]
      this.$router.push({ name: 'SaveContractUpdate', params: { node, id_contract: node.id } })
    },

    getPage (pageNum) {
      const params = {
        page: pageNum,
        sort: this.paramsWidthSort.sort,
        search: this.paramsWidthSort.search
      }
        this.$store.dispatch('contracts/getContractsListPage', params)
    },

    sortContracts(col, sort) {
      this.paramsWidthSort = {
        page: 1,
        sort: (sort ? "" : "-") + col?.value,
        search: this.paramsWidthSort.search
      }
      this.$store.dispatch('contracts/getContractsListPage', this.paramsWidthSort)
    },

    select(value, index, all = null) {
      if (all !== null) {
        this.selectedIndices = all ? this.contracts.map((el, i) => i) : [];
      } else if (value) {
        this.selectedIndices = [...this.selectedIndices, index];
      } else {
        this.selectedIndices = this.selectedIndices.filter((i) => i === index);
      }
    },


    delete() {
      if (this.selectedContractsIds.length) {
        const deleteCallback = async () => {
          this.selectedContractsIds.map(({ id }) => {
            deleteContracts(id).finally(() => this.getContracts())
          })
          this.selectedContractsIds = []
          this.$root.alert("Договора успешно удалены")
          // const params = {
          //   page: this.pagination.currentPage,
          //   sort: this.paramsWidthSort.sort,
          //   search: this.paramsWidthSort.search
          // }
          // this.$store.dispatch('contracts/getContractsListPage', params)
        }
        this.$root.confrim(
          "Вы уверены, что хотите удалить договора?",
          deleteCallback,
          "Да"
        );
      }
    },

    create() {
      this.$router.push({ name: 'SaveContractCreate' })
    }
  },

  destroyed () {
    this.$store.commit('contracts/RESET_CONTRACTS_LIST_CURRENT_PAGE')
  },

  watch: {
    search(val) {
      this.paramsWidthSort = {
        page: 1,
        sort: this.paramsWidthSort.sort,
        search: val
      }
      this.$store.dispatch('contracts/getContractsListPage', this.paramsWidthSort)
    },
  },
}
</script>
